import * as React from "react";
import Button from "@mui/material/Button";
import Dialog, { DialogProps } from "@mui/material/Dialog";
import { Grid, IconButton } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CloseIcon from "@mui/icons-material/Close";
import * as Converter from "persian-currency-converter";
import CheckFormatCmp from "../../components/checkInfoComponent/checkFormatCmp";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";

export default function ViewCheckInformationModal(props: any) {
  let accumulative = false;
  // if (props.fileData.isAccumulative == true && props.fileData.accumulativeAmount == props.fileData.inquiryAmount) {
  //     accumulative = true;
  // }
  const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const maxWidth: DialogProps["maxWidth"] = "lg";

  return (
    <div className="dialogCheque">
      <MoreHorizIcon
        scale="scale(1.8) "
        className="cursorPointer"
        style={{ color: "#fff", width: "24px", height: "24px" }}
        onClick={handleClickOpen}
      />
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        // maxWidth={maxWidth}
        PaperProps={{
          sx: {
            width: "80%",
            maxWidth: "none",
            maxHeight: "100%",
            overflowY: "unset",
            padding: "10px 20px 20px 10px",
          },
        }}
      >
        <>
          <IconButton onClick={handleClose}>
            <CloseIcon
              style={{
                position: "absolute",
                zIndex: "1",
                left: "0",
                color: "red",
                marginLeft: "5px",
                marginTop: "3vh",
              }}
            />
          </IconButton>

          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
            style={{ marginTop: "7vh", marginBottom: "7vh" }}
          >
            <Grid
              container
              className="cardDesign"
              spacing={{ xs: 2, md: 3 }}
              columns={{ xs: 4, sm: 8, md: 12 }}
            >
              <Grid
                item
                xs={8}
                md={8}
                sm={12}
                style={{
                  borderLeft: "1px solid #DAE0E4",
                  marginBottom: "0px !imortant",
                }}
              >
                <div
                  style={{
                    marginRight: "6vh",
                    marginLeft: "6vh",
                    marginTop: "4vh",
                  }}
                >
                  <img
                    style={{ width: "90%", height: "30vh" }}
                    className="classCenter objectFit"
                    src={props.fileData.file?.fileUrl}
                    alt="طرح انتخابی"
                  />
                </div>
              </Grid>
              <Grid item xs={4}>
                <div
                  style={{
                    marginRight: "6vh",
                    marginLeft: "6vh",
                    marginBottom: "6vh",
                  }}
                >
                  {accumulative ? (
                    <Grid item xs={6}>
                      <p className="sayadyAccumulative">بارگذاری چک تجمیعی</p>
                    </Grid>
                  ) : (
                    ""
                  )}

                  <CheckFormatCmp
                    priceTitle={"مبلغ به عدد (ریال): "}
                    price={props.fileData.amount?.toLocaleString()}
                    priceInWordTitle={"مبلغ به حروف : "}
                    priceInWord={Converter.convertToPersianWord(
                      Number(props.fileData.amount)
                    )}
                    supplierTitle={"در وجه: "}
                    supplier={props.fileData.expectedHolder}
                    dateTitle={"تاریخ سررسید: "}
                    date={props.fileData.dueDatePersian}
                    signerTitle={"امضاء کننده چک : "}
                    signer={props.fileData.signer}
                    checkTypeTitle={"نوع چک : "}
                    checkType={"اقساط"}
                    // descriptionTitle={"توضیحات: "}
                    // description={props.description}
                    nationalTitle={"شناسه ملی: "}
                    national={props.fileData.expectedIdCode}
                    checkSerialTitle={"سری / سریال چک: "}
                    checkSerial={
                      props.fileData.seriesNo + " / " + props.fileData.serialNo
                    }
                    sayadiTitle={"َشماره صیادی: "}
                    sayadi={props.fileData.sayadNumber}
                    fromIbanTitle={"َشماره شبا: "}
                    fromIban={props.fileData.fromIban}
                    branchCodeTitle={"کد شعبه صادر کننده : "}
                    branchCode={props.fileData.branchCode}
                    // bankTitle={"بانک و شعبه صادر کننده:"}
                    // bank={"بانک شهر"}
                  />
                  <div
                    style={{
                      // height:'45px',
                      lineHeight: "25px",
                      display: "inline-block",
                      textAlign: "center",
                      padding: "10px",
                      borderRadius: "4px",
                    }}
                    className="disabledTransparent classCenter "
                  >
                    <b className="SuccessDefaultFont ">
                      نتیجه استعلام{" "}
                      <CheckCircleIcon className="SuccessDefaultFont" />
                    </b>
                  </div>
                </div>
              </Grid>
            </Grid>
          </Grid>
        </>
      </Dialog>
    </div>
  );
}
